import { UntypedFormBuilder } from '@angular/forms';
import { Injectable } from '@angular/core';
import { INimbusFormGroup } from './i-nimbus-form-group';
import { NimbusFormGroupWrapper } from './nimbus-form-group-wrapper';
import { INimbusFormBuilder } from './i-nimbus-form-builder';
import { NimbusFormControls } from './nimbus-form-controls.type';

@Injectable({ providedIn: 'root' })
export class NimbusFormGroupBuilder {
  public readonly formBuilder: INimbusFormBuilder;

  public constructor(formBuilder: UntypedFormBuilder) {
    this.formBuilder = formBuilder as INimbusFormBuilder;
  }

  public group<TForm>(controls: NimbusFormControls<TForm>): NimbusFormGroupWrapper<TForm> {
    const form = this.formBuilder.group<TForm>(controls);
    return new NimbusFormGroupWrapper<TForm>(form as INimbusFormGroup<TForm>);
  }
}
